import { ROUTES_UPLOAD_SESSION_FILES } from '@/constants/routes';

export default {
    path: '/upload-session-files',
    name: ROUTES_UPLOAD_SESSION_FILES,
    component: () => import('@/views/UploadSessionFiles.vue')
};
